// removed by extract-text-webpack-plugin
module.exports = {"curtain":"CurtainComponent__curtain___2u0P5","closed":"CurtainComponent__closed___tb_WB"};


//////////////////
// WEBPACK FOOTER
// ./src/game/menus/CurtainComponent.scss
// module id = 152
// module chunks = 0